exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.createBaseTemp.el-button--medium {\r\n  padding: 10px 16px;\n}\n.TempList .el-tabs__content {\r\n  width: 200px;\n}\n.m-colorPicker .colorBtn {\r\n  border: 1px solid #000;\r\n  width: 20px !important;\r\n  height: 20px !important;\n}\r\n", ""]);

// exports
